import { RoutePath } from 'src/routes/types';

import { NavigationState } from './types';

export const defaultSegments: RoutePath[] = [RoutePath.Main];

export const initialState: NavigationState = {
  segments: defaultSegments,
};
